import { render, staticRenderFns } from "./DiyIcon.vue?vue&type=template&id=6be5d54e&scoped=true"
import script from "./DiyIcon.vue?vue&type=script&lang=js"
export * from "./DiyIcon.vue?vue&type=script&lang=js"
import style0 from "./DiyIcon.vue?vue&type=style&index=0&id=6be5d54e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6be5d54e",
  null
  
)

export default component.exports